import { enumify } from '../lib/typeInference.js';

export const paymentProviderValues = ['BRAINTREE', 'JUDOPAY', 'STRIPE', 'SQUARE', 'WORLDPAY', 'POWERCARD', 'TOGGLE', 'REVEL', 'DOJO', 'EAGLE_EYE', 'NONE'] as const;

export type PaymentProvider = (typeof paymentProviderValues)[number];
export const PaymentProviderEnum = enumify(paymentProviderValues);
